import React from 'react';
import { CLAN_COLUMNS } from '../../metadata/fields.js';

function ClanStatsDetailsTable({ clanData, selectedPeriod }) {
    const currentPeriodStats = clanData?.filter((stats) => {
        return stats['period'] === selectedPeriod
    });
    const statHeaders = Object.keys(CLAN_COLUMNS).map(column => {
        return (
            <th>{ CLAN_COLUMNS[column].label }</th>
        )
    });

    const statCells = currentPeriodStats?.length > 0 ? Object.keys(CLAN_COLUMNS).map(column => {
        
        return (
            <>
                <td className="mobile-header"><b>{ CLAN_COLUMNS[column].label }</b></td>
                <td><span>{ CLAN_COLUMNS[column].formatter ? CLAN_COLUMNS[column].formatter(currentPeriodStats[0][column]) : currentPeriodStats[0][column] }</span></td>
            </>
        )
    }) : null;

    const blankCells = Array(Object.keys(CLAN_COLUMNS).length).fill(
        <>
            <td className="mobile-header"/>
            <td/>
        </>
    );

    return (
        <table className="clanleaderboard_table_clan">
            <thead>
                <tr>
                    { statHeaders }
                </tr>
            </thead>
            <tbody>
                <tr>
                    { currentPeriodStats?.length > 0 ? statCells : blankCells }
                </tr>
            </tbody>
        </table>
    )
}

export default ClanStatsDetailsTable;
